<template>
  <Doughnut
    :id="id"
    :data="data"
    :options="options"
    :plugins="plugins"
  />
</template>

<script setup>
import { Doughnut } from 'vue-chartjs';
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend, LinearScale, CategoryScale,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, LinearScale, CategoryScale);

defineProps({
  id: {
    type: String,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
  plugins: {
    type: Array,
    default: () => [],
  },
});
</script>
